<template lang="html">

  <header class="app-header" :animation="showanimation" :show="showmenu">


    <div class="top row-start ais">

      <div class="left row-between">
        <router-link to="/">
          <img class="logo" src="/static/img/logo-fiesta.svg" alt="Logo fiesta">
        </router-link>
        <div class="right row-end">
          <nav class="main-menu row-end" v-if="!hideoptionsmenu">
            <router-link :to="$t('enlaces.productos')">{{$t('productos.titulo')}}</router-link>
            <router-link v-if="!!promociones && promociones.length != 0" :to="$t('enlaces.promociones')">{{$t('promociones.titulo')}}</router-link>
            <router-link v-if="!!noticias && noticias.length != 0" :to="$t('enlaces.novedades')">{{$t('novedades.titulo')}}</router-link>
          </nav>
          <span class="show-menu-container" @click="showmenu= !showmenu">
            <figure>{{(showmenu) ? $t('generales.cerrar') :  $t('generales.menu')}}</figure>
            <button class="show-menu">
              <span></span>
              <span></span>
              <span></span>
              <i class="close row-center">✕</i>
            </button>
          </span>
        </div>

      </div>

      <div class="tienda-container row-center">

        <a class="enlace-tienda" href="https://tienda.fiesta.es/" target="_blank">
          <img src="/static/img/carrito-tienda.svg" alt="">
          {{$t('generales.tienda')}}
        </a>

      </div>

    </div>

    <div class="secondary-menu row-center">
      <div class="contenedor-menu">
        <nav class="column-start menu-nav">
          <router-link class="row-start" :to="$t('enlaces.metelefiesta')" @click.native="hidemenu">
            <img src="/static/img/metele-fiesta-menu.svg" alt="Metelé Fiesta">
          </router-link>
          <router-link class="mvl" @click.native="hidemenu" :to="$t('enlaces.productos')">{{$t('productos.titulo')}}
          </router-link>
          <router-link class="mvl" v-if="!!promociones && promociones.length != 0" @click.native="hidemenu" :to="$t('enlaces.promociones')">{{$t('promociones.titulo')}}
          </router-link>
          <router-link class="mvl" v-if="!!noticias && noticias.length != 0" @click.native="hidemenu" :to="$t('enlaces.novedades')">{{$t('novedades.titulo')}}
          </router-link>
          <div class="family" :on="showsobrefiesta" @mouseleave="showsobrefiesta= false">
            <a class="with-children" :on="showsobrefiesta" @mouseover="overSobreFiesta">{{$t('fiestahoy.sobrefiesta.titulo')}}</a>
            <div class="children column-start" :show="showsobrefiesta">
              <router-link class="small" :to="$t('enlaces.fiestahoy')" @click.native="hidemenu">{{$t('fiestahoy.titulo')}}</router-link>
              <router-link class="small" :to="$t('enlaces.historia')">{{$t('historia.titulo')}}</router-link>
              <router-link class="small" :to="$t('enlaces.fiestamundo')" @click.native="hidemenu">
                {{$t('fiestamundo.titulosmall')}}</router-link>
            </div>
          </div>
          <router-link :to="$t('enlaces.calidad')" @click.native="hidemenu">{{$t('calidad.titulo')}}</router-link>
          <router-link :to="$t('enlaces.distribucion')" @click.native="hidemenu">{{$t('distribucion.titulo')}}</router-link>
          <router-link :to="$t('enlaces.contacto')" @click.native="hidemenu">{{$t('contacto.titulo')}}</router-link>
        </nav>

        <img src="/static/img/menu/acidtwist.png" alt="Acidtwist" class="decoracion acidtwist">
        <img src="/static/img/menu/piruleta.png" alt="Piruleta helada" class="decoracion bokados">
        <img src="/static/img/menu/lolipop.png" alt="Cookies" class="decoracion cookies-1">
        <img src="/static/img/menu/lolipop.png" alt="Cookies 2" class="decoracion cookies">
        <img src="/static/img/menu/freskito.png" alt="Freskito" class="decoracion freskito">
        <img src="/static/img/menu/freskito.png" alt="Freskito 2" class="decoracion freskito-1">
        <img src="/static/img/menu/kojakpower.png" alt="Kojak Power" class="decoracion kojakpower">
        <img src="/static/img/menu/lolipop.png" alt="Lolipop" class="decoracion lolipop">
        <img src="/static/img/menu/lolipop.png" alt="Lolipop 2" class="decoracion lolipop-1">
        <img src="/static/img/menu/megatorcidas.png" alt="Megatorcidas" class="decoracion megatorcidas">
        <img src="/static/img/menu/piruleta.png" alt="Piruleta" class="decoracion piruleta">
        <img src="/static/img/menu/piruleta.png" alt="Piruleta 2" class="decoracion piruleta-1">
        <img src="/static/img/menu/kojak.png" alt="Kojak" class="decoracion kojak">
        <img src="/static/img/menu/brownie.png" alt="Brownie" class="decoracion brownie">

      </div>

    </div>

  </header>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default {
    name: 'app-header',
    mounted() {
      setTimeout(e => {
        this.showanimation = true;
      }, 1000);
    },
    methods: {
      hidemenu() {
        this.showmenu = false;
      },
      overSobreFiesta() {
        if (!this.showsobrefiesta) {
          this.showsobrefiesta = true;
        }
      }
    },
    data() {
      return {
        showanimation: false,
        showmenu: false,
        showsobrefiesta: false
      }
    },
    watch: {
      '$route'() {
        this.showmenu = false;
        this.showsobrefiesta = false;
      },
      'showmenu'() {
        if (this.showmenu) {
          if ($(window).width() <= 620) {
            this.showsobrefiesta = true;
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        noticias : 'getNoticias',
        promociones : 'getpromociones'
      }),
      hideoptionsmenu() {
        let hideIn = ['cod'];
        return hideIn.some(e => e == this.$route.name);
      }
    }
  }
</script>

<style scoped>
  .header {}
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue